import { render, staticRenderFns } from "./DialogSenhas.vue?vue&type=template&id=2c83bd68"
import script from "./DialogSenhas.vue?vue&type=script&lang=js"
export * from "./DialogSenhas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports